import { defineMessages } from 'react-intl';

export const scope = 'app.components.ParentContactsSection';

// Copy for the signed-in parent's contacts card on the player page.
export const messages = defineMessages({
  sectionTitle: {
    id: `${scope}.sectionTitle`,
    defaultMessage: 'Contacts'
  },
  manageContactDetails: {
    id: `${scope}.manageContactDetails`,
    defaultMessage: 'Manage my contact details'
  }
});
